import { useFormik } from "formik";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import {
    createAPIdistCollatrldisp,
    Endpoint,
} from "../../Services/DistributorCollateralDispatch/DistrCollateralDis";
import storage from "../../Services/Storage";
import * as Yup from "yup";
import { useEmployeeMasterContext } from "../../context/EmployeeMasterContext";
// import { CiGlass } from "react-icons/ci";
import SearchGeographyModal from "../EmployeeMaster/SearchGeographyModal";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";

const DistributorCollateralDispatchAddress = () => {
    const {
        setTownPopup,
        townValue,
        stateValue,
        districtValue,
        confirmTown,
        zipCode,
        setZipCode,
        handleState,
        setstateValue,
        setTownValue,
        setDistrictValue,
        setConfirmTown,
    } = useEmployeeMasterContext();

    const [allformData, setAllformData] = useState();
    const [saveloader, setSaveloader] = useState(false);
    const auth = storage.getLocal("user");
    useEffect(() => {
        const populatedata = () => {
            createAPIdistCollatrldisp()
                .get(`${Endpoint.PopulateData}?UserId=${auth.UserId}`)
                .then((res) => {
                    setAllformData(res.data.Data[0]);
                })
                .catch((error) => {
                    console.log(error);
                });
        };
        populatedata();
        handleState();
        setConfirmTown(false);
        setstateValue("");
        setDistrictValue("");
        setTownValue("");
        setZipCode("");
    }, []);

    const initialValues = {
    //Address
        addressLine1: "",
        addressLine2: "",
        town: "",
        state: "",
        district: "",
        zipCode: "",
        stdCode: "",
        phoneNumber: "",
        mobileNo: "",
        validate: false,
    };

    const validationSchemadist = Yup.object({
        addressLine1: Yup.string()
            .max(100, "Must be 100 characters or less")
            .required("Address Line 1 is required"),
        addressLine2: Yup.string().max(100, "Must be 100 characters or less"),
        town: Yup.string(),
        state: Yup.string(),
        district: Yup.string(),
        zipCode: Yup.string().required("Town can't be empty"),
        stdCode: Yup.string()
            .matches(/^\d{0,4}$/, "Must be a number and up to 4 digits")
            .required("STD Code is required"),
        phoneNumber: Yup.string()
            .matches(/^\d{0,10}$/, "Must be a number and up to 10 digits")
            .required("Phone Number is required"),
        mobileNo: Yup.string()
            .matches(/^\d{10}$/, "Mobile number must be a 10-digit number") // Validate 10 digits
            .required("Mobile number is required"),
        validate: Yup.boolean(),
    });

    useEffect(() => {
        if (allformData) {
            formik.setValues({
                addressLine1: allformData.ADD_LINE_1,
                addressLine2: allformData.ADD_LINE_2,
                town: allformData.TOWN,
                state: allformData.STATE,
                district: allformData.DISTRICT,
                zipCode: allformData.PIN_CODE,
                stdCode: allformData.STD_CODE,
                phoneNumber: allformData.PHONE_NO,
                mobileNo: allformData.OTHER_PHONE_NO,
                validate: allformData.VALIDATED == "Y" ? true : false,
            });
        }
    }, [allformData]);

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchemadist,
        onSubmit: (data) => {
            updatedispatchData(data);
        },
    });
    // console.log(formik);

    const updatedispatchData = (data) => {
        // console.log("form data", data);
        let savepayoad = {
            userId: auth.UserId,
            compId: auth.CompId,
            txtAdd1: data.addressLine1,
            txtAdd2: data.addressLine2,
            txtTown: data.town,
            txtPin: data.zipCode,
            txtStdCode: data.stdCode,
            txtPhnNo: data.phoneNumber,
            txtOtherPhnNo: data.mobileNo,
            temintnflag: allformData.TERMINATION_FLAG,
            states: data.state,
            district: data.district,
            chkAddressStat: data.validate ? "Y" : null,
        };
        setSaveloader(true);
        createAPIdistCollatrldisp()
            .post(
                `${Endpoint.Update}`,
                JSON.stringify(savepayoad),
                {
                    headers: { "Content-Type": "application/json" },
                }
            )
            .then((res) => {
                if (res.data.Status === "Success") {
                    toast.success(res.data.Message, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                } else if (res.data.Status === "Warning") {
                    toast.warn(res.data.Message, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                }
                setSaveloader(false);
            })
            .catch((error) => {
                console.log(error);
                toast.warn(error.response.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                setSaveloader(false);
            });
        // console.log(savepayoad);
    };
    if (saveloader) {
        return <Loader />;
    } else {
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Distributor Collateral Dispatch Address</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12"></div>
                    </div>
                    <section className="sales-box">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      Address 1 <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            className="form-control"
                                            id="addressLine1"
                                            name="addressLine1"
                                            value={formik.values.addressLine1}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.addressLine1 &&
                    formik.errors.addressLine1 ? (
                                                <small className="p-error">
                                                    {formik.errors.addressLine1}
                                                </small>
                                            ) : null}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">Address 2</label>
                                        <InputText
                                            className="form-control"
                                            id="addressLine2"
                                            name="addressLine2"
                                            value={formik.values.addressLine2}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.addressLine2 &&
                    formik.errors.addressLine2 ? (
                                                <small className="p-error">
                                                    {formik.errors.addressLine2}
                                                </small>
                                            ) : null}
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      Town <span className="mandatory">*</span>
                                        </label>
                                        <div
                                            className="input-group"
                                            style={{ display: "flex", alignItems: "center" }}
                                        >
                                            <InputText
                                                class="form-control"
                                                type="text"
                                                placeholder="Select"
                                                id="town"
                                                name="town"
                                                value={
                                                    !confirmTown
                                                        ? formik.values.town
                                                        : (formik.values.town = townValue)
                                                }
                                                onChange={(e) => {
                                                    formik.setFieldValue("town", e.target.value);
                                                }}
                                                disabled
                                                style={{ flex: "1" }}
                                            />
                                            <div className="input-group-prepend">
                                                <span
                                                    onClick={() => {
                                                        setTownPopup(true);
                                                    }}
                                                    className="input-group-text ms-2"
                                                >
                                                    <Fa.FaSearch />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">District</label>
                                        <InputText
                                            class="form-control"
                                            id="district"
                                            name="district"
                                            value={
                                                !confirmTown
                                                    ? formik.values.district
                                                    : (formik.values.district = districtValue)
                                            }
                                            onChange={(e) => {
                                                formik.setFieldValue("district", e.target.value);
                                            }}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">State</label>
                                        <InputText
                                            class="form-control"
                                            id="state"
                                            name="state"
                                            value={
                                                !confirmTown
                                                    ? formik.values.state
                                                    : (formik.values.state = stateValue)
                                            }
                                            onChange={(e) => {
                                                formik.setFieldValue("state", e.target.value);
                                            }}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">Pin Code</label>
                                        <InputText
                                            className="form-control"
                                            id="zipCode"
                                            name="zipCode"
                                            value={
                                                !confirmTown
                                                    ? formik.values.zipCode
                                                    : (formik.values.zipCode = zipCode.slice(0, 6))
                                            }
                                            onChange={(e) => {
                                                formik.setFieldValue("zipCode", e.target.value);
                                            }}
                                            onBlur={formik.handleBlur}
                                            disabled
                                        />
                                        {formik.touched.zipCode && formik.errors.zipCode ? (
                                            <small className="p-error">{formik.errors.zipCode}</small>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      STD Code <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            className="form-control"
                                            id="stdCode"
                                            name="stdCode"
                                            value={formik.values.stdCode}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.stdCode && formik.errors.stdCode ? (
                                            <small className="p-error">{formik.errors.stdCode}</small>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      Phone Number <span className="mandatory">*</span>
                                        </label>

                                        <InputText
                                            className="form-control"
                                            id="phoneNumber"
                                            name="phoneNumber"
                                            value={formik.values.phoneNumber}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                                            <small className="p-error">
                                                {formik.errors.phoneNumber}
                                            </small>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      Mobile Number <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            className="form-control"
                                            id="mobileNo"
                                            name="mobileNo"
                                            value={formik.values.mobileNo}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.mobileNo && formik.errors.mobileNo ? (
                                            <small className="p-error">
                                                {formik.errors.mobileNo}
                                            </small>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="col-lg-8 col-md-12 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      Validate <span className="mandatory">*</span>
                                        </label>
                                        <InputSwitch
                                            className="switch-pos ms-2"
                                            id="validate"
                                            name="validate"
                                            checked={formik.values.validate}
                                            onChange={(e) => {
                                                formik.setFieldValue("validate", e.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                    <div className="text-end mt-3">
                                        <button type="submit" className="btn btn-primary">
                      Update
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                </div>
                <SearchGeographyModal />
            </>
        );
    }
};

export default DistributorCollateralDispatchAddress;
